import EventService from "../services/EventService";

export default {
  namespaced: true,
  state: {
    events: [
      // {
      //   id: 'id1',
      //   start: new Date(),
      //   end: new Date(),
      //   host: 'Van',
      //   title: "Họp Sale",
      //   date: new Date(),
      // },
      // {
      //   id: 'id2',
      //   start: new Date(),
      //   end: new Date(),
      //   host: 'Van',
      //   title: "Họp Sale 2",
      //   date: new Date()
      // },
      // {
      //   id: "id3",
      //   date: new Date("Sat Nov 02 2019 00: 00: 00"),
      //   end: new Date("Fri Nov 01 2019 21: 56: 18"),
      //   host: "van",
      //   start: new Date("Fri Nov 01 2019 09: 56: 18"),
      //   title: "van hop booking"
      // }
    ],
    searchEvents: []
  },
  mutations: {
    addEvent (state, event) {
      state.events.push(event)
    },

    updateEvent (state, payload) {
      for (let i = 0; i < state.events.length; i++) {
        if (state.events[i].id === payload.id) {
          state.events[i].start = payload.start
          state.events[i].end = payload.end
          state.events[i].email = payload.email
          state.events[i].title = payload.title
          state.events[i].date = payload.date
          state.events[i].message = payload.message
        }
      }
    },

    setSearchEvents (state, value) {
      state.searchEvents = value
    },

    saveEvents (state, value) {
      state.events = value
    }

  },
  actions: {

    setSearchEvents ({ commit }, value) {
      commit('setSearchEvents', value)
    },

    async fetchEvents ({ rootState, commit }) {
      const { username } = rootState.auth;
      try {
        const res = await EventService.fetchEvents(
          { username },
          rootState.auth.token
        );
        if (res) {
          commit("saveEvents", res.data.data);
        }
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },

    async createEvent ({ rootState, dispatch }, event) {
      const newEvent = {
        username: rootState.auth.username,
        event
      };
      try {
        const res = await EventService.createEvent(
          newEvent,
          rootState.auth.token
        );
        dispatch("fetchEvents");
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async removeEvent ({ rootState, dispatch }, eventId) {
      try {
        const res = await EventService.removeEvent(
          { id: eventId },
          rootState.auth.token
        );
        dispatch("fetchEvents");
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async updateEvent ({ rootState, dispatch }, event) {
      try {
        const res = await EventService.updateEvent(
          { event: event },
          rootState.auth.token
        );
        dispatch("fetchEvents");
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    getConference({ commit, rootState }, params) {
      return EventService.getEventId(params, rootState.auth.token).then(res => {
        return res
      })
    }
  }
};